import { ShipmentScanEventType } from './../types/main/ShipmentType'

class Shipment {
	constructor({
		id = '',
		orderId = '',
		dispatchId = '',
		carrier = 'fedex',
		serviceType = '',
		trackingNumber = '',
		boxId = '',
		boxCode = '',
		widthCm = 0,
		heightCm = 0,
		depthCm = 0,
		weightKg = 0,
		labelMime = '',
		hasLabel = 0,
		lastStatusCode = '',
		lastStatusDesc = '',
		lastTrackedAt = '',
		scanEvents = [] as ShipmentScanEventType[],
		deliveredAt = '',
		canceledAt = '',
		status = 'created',
		receiverName = '',
		customerEmail = '',
		country = '',
		countryCode = '',
		city = '',
		stateIsoCode = '',
		updatedAt = '',
		updatedBy = '',
		createdAt = '',
		createdBy = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.orderId = orderId === null ? '' : orderId
		this.dispatchId = dispatchId === null ? '' : dispatchId
		this.carrier = carrier === null ? 'fedex' : carrier
		this.serviceType = serviceType === null ? '' : serviceType
		this.trackingNumber = trackingNumber === null ? '' : trackingNumber
		this.boxId = boxId === null ? '' : boxId
		this.boxCode = boxCode === null ? '' : boxCode
		this.widthCm = widthCm === null ? 0 : Number(widthCm)
		this.heightCm = heightCm === null ? 0 : Number(heightCm)
		this.depthCm = depthCm === null ? 0 : Number(depthCm)
		this.weightKg = weightKg === null ? 0 : Number(weightKg)
		this.labelMime = labelMime === null ? '' : labelMime
		this.hasLabel = hasLabel === null ? 0 : Number(hasLabel)
		this.lastStatusCode = lastStatusCode === null ? '' : lastStatusCode
		this.lastStatusDesc = lastStatusDesc === null ? '' : lastStatusDesc
		this.lastTrackedAt = lastTrackedAt === null ? '' : lastTrackedAt
		this.scanEvents = Array.isArray(scanEvents) ? scanEvents : []
		this.deliveredAt = deliveredAt === null ? '' : deliveredAt
		this.canceledAt = canceledAt === null ? '' : canceledAt
		this.status = status === null ? 'created' : status
		this.receiverName = receiverName === null ? '' : receiverName
		this.customerEmail = customerEmail === null ? '' : customerEmail
		this.country = country === null ? '' : country
		this.countryCode = countryCode === null ? '' : countryCode
		this.city = city === null ? '' : city
		this.stateIsoCode = stateIsoCode === null ? '' : stateIsoCode
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.createdAt = createdAt === null ? '' : createdAt
		this.createdBy = createdBy === null ? '' : createdBy
	}
	id: string
	orderId: string
	dispatchId: string
	carrier: string
	serviceType: string
	trackingNumber: string
	boxId: string
	boxCode: string
	widthCm: number
	heightCm: number
	depthCm: number
	weightKg: number
	labelMime: string
	hasLabel: number
	lastStatusCode: string
	lastStatusDesc: string
	lastTrackedAt: string
	scanEvents: ShipmentScanEventType[]
	deliveredAt: string
	canceledAt: string
	status: string
	receiverName: string
	customerEmail: string
	country: string
	countryCode: string
	city: string
	stateIsoCode: string
	updatedAt: string
	updatedBy: string
	createdAt: string
	createdBy: string
}

export { Shipment }
